import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  Home, 
  TrendingUp, 
  Map, 
  BarChart3, 
  Settings,
  X 
} from 'lucide-react';

const Sidebar = ({ open, setOpen }) => {
  const navigate = useNavigate();
  
  const navItems = [
    { to: '/', icon: Home, label: 'Home' },
    { to: '/trends', icon: TrendingUp, label: 'Trends' },
    { to: '/heatmap', icon: Map, label: 'Heatmap' },
    { to: '/analytics', icon: BarChart3, label: 'Analytics' },
    { to: '/settings', icon: Settings, label: 'Settings' },
  ];

  const handleCategoryClick = (category) => {
    setOpen(false);
    navigate(`/trends?category=${category.toLowerCase()}`);
  };

  return (
    <>
      {/* Overlay for mobile */}
      {open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`
          fixed top-16 left-0 z-40 h-[calc(100vh-4rem)]
          w-64 bg-white dark:bg-dark-card
          border-r border-reddit-200 dark:border-dark-border
          transition-transform duration-300 ease-in-out
          ${open ? 'translate-x-0' : '-translate-x-full'}
          lg:translate-x-0
        `}
      >
        <div className="flex flex-col h-full p-4">
          {/* Close button for mobile */}
          <button
            onClick={() => setOpen(false)}
            className="lg:hidden self-end p-2 mb-4 rounded-md hover:bg-reddit-100 dark:hover:bg-dark-border"
          >
            <X className="w-5 h-5" />
          </button>

          {/* Navigation Links */}
          <nav className="space-y-2">
            {navItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `reddit-nav-link flex items-center gap-3 w-full ${
                      isActive ? 'active' : ''
                    }`
                  }
                >
                  <Icon className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </NavLink>
              );
            })}
          </nav>

          {/* Trending Categories */}
          <div className="mt-8">
            <h3 className="text-xs font-semibold text-reddit-600 dark:text-dark-textMuted uppercase tracking-wider mb-3">
              Categories
            </h3>
            <div className="space-y-2">
              {['Technology', 'Politics', 'Sports', 'Entertainment', 'Business'].map((category) => (
                <button
                  key={category}
                  onClick={() => handleCategoryClick(category)}
                  className="w-full text-left px-3 py-2 text-sm rounded-md hover:bg-reddit-100 dark:hover:bg-dark-border hover:text-reddit-orange dark:hover:text-reddit-orange transition-colors font-medium"
                >
                  {category}
                </button>
              ))}
            </div>
          </div>

          {/* Footer info */}
          <div className="mt-auto pt-4 border-t border-reddit-200 dark:border-dark-border">
            <p className="text-xs text-reddit-600 dark:text-dark-textMuted">
              Real-time trending data from multiple sources
            </p>
          </div>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;